const __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof platform_emrge_taxonomy !== "undefined") return resolve();
	__webpack_require__.l("https://emrge-taxonomy-1054217893522.us-central1.run.app/remoteEntry.js", (event) => {
		if(typeof platform_emrge_taxonomy !== "undefined") return resolve();
		const errorType = event && (event.type === 'load' ? 'missing' : event.type);
		const realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "platform_emrge_taxonomy");
}).then(() => (platform_emrge_taxonomy));